(() => {
  const STORAGE_KEY = 'linked-product-swatches-scroll';

  function saveScrollForUrl(url) {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          to: url,
          scrollY: window.scrollY
        })
      );
    } catch (e) {}
  }

  function restoreScrollIfNeeded() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;

      const data = JSON.parse(raw);
      const currentUrl = window.location.pathname + window.location.search;

      if (!data || data.to !== currentUrl || typeof data.scrollY !== 'number') return;

      requestAnimationFrame(() => {
        window.scrollTo({ top: data.scrollY, left: 0, behavior: 'auto' });
        requestAnimationFrame(() => {
          window.scrollTo({ top: data.scrollY, left: 0, behavior: 'auto' });
          sessionStorage.removeItem(STORAGE_KEY);
        });
      });
    } catch (e) {}
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches('input[data-linked-product-url]')) return;

    const productUrl = input.dataset.linkedProductUrl;
    if (!productUrl) return;

    const absoluteUrl = new URL(productUrl, window.location.origin);
    const targetPath = absoluteUrl.pathname + absoluteUrl.search;

    const isPdpLinkedSwatch = !!input.closest('.linked-product-swatches');

    if (isPdpLinkedSwatch) {
      saveScrollForUrl(targetPath);
    }

    window.location.href = absoluteUrl.toString();
  });

  window.addEventListener('pageshow', restoreScrollIfNeeded);
  document.addEventListener('DOMContentLoaded', restoreScrollIfNeeded);
})();